import { render, staticRenderFns } from "./Game5-12.vue?vue&type=template&id=e91c969e&scoped=true&"
import script from "./Game5-12.vue?vue&type=script&lang=js&"
export * from "./Game5-12.vue?vue&type=script&lang=js&"
import style0 from "./Game5-12.vue?vue&type=style&index=0&id=e91c969e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91c969e",
  null
  
)

export default component.exports